export default "__VITE_ASSET__u$QOZmex__"